import React from 'react';
import { images } from '../data/landing';
export function AuthorSection() {
  return <section className="w-full bg-cream py-20 lg:py-24" data-id="element-33" data-mp="sbfwinhsvjvc">
      <div className="mx-auto grid max-w-content grid-cols-1 items-center gap-10 px-6 lg:grid-cols-[0.85fr_1fr] lg:gap-16" data-id="element-34" data-mp="saxwdfs0oli5">
        <figure className="overflow-hidden rounded-[2rem]" data-id="element-35" data-mp="129dljd7hhkp0">
          <img src={images.author} alt="El autor dando una clase de running al atardecer" className="h-80 w-full object-cover lg:h-[30rem]" width={1200} height={900} data-id="element-36" data-mp="129wrdvjv0imo" />
        </figure>

        <div data-id="element-37" data-mp="oa464fr3qum3">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.18em] text-nature-dark" data-id="element-38" data-mp="o9uc8h2xs3b4">
            Sobre el autor
          </p>
          <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-39" data-mp="jhktpm45i5iv">
            De corredor a arquitecto de equipos.
          </h2>
          <blockquote className="mt-7 space-y-5 text-lg leading-relaxed text-ink-soft" data-id="element-40" data-mp="3myt8fx3l0p9d">
            <p data-id="element-41" data-mp="2vmsl6f58g4g8">
              “Yo también estuve ahí: con 5 alumnos, cobrando poco y sintiendo
              que cada clase era una hoja en blanco.
            </p>
            <p data-id="element-42" data-mp="34g5l411ps6bt">
              Diseñé este pack porque el running me cambió la vida y quiero que
              vos tengas{' '}
              <span className="font-semibold text-ink" data-id="element-43" data-mp="39fi7kkoobbdv">
                el sistema que a mí me tomó 10 años construir
              </span>
              .”
            </p>
          </blockquote>
        </div>
      </div>
    </section>;
}